var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', [_c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', [_c('legend', [_vm._v("RVP Hold Return")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Select SR")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.srList,
      "selected-option": _vm.srItemObj,
      "name": "SR",
      "placeholder": "Select SR"
    },
    on: {
      "select": _vm.selectSR
    },
    model: {
      value: (_vm.srId),
      callback: function($$v) {
        _vm.srId = $$v
      },
      expression: "srId"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('SR')),
      expression: "errors.has('SR')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('SR')) + "\n                                            ")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Select Date")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      error: _vm.errors.has('fromDate')
    },
    attrs: {
      "id": "fromDate",
      "type": "date",
      "name": "fromDate",
      "max": _vm.currentDate
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fromDate')),
      expression: "errors.has('fromDate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n                                                Please Select From Date\n                                            ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-input-group', {
    staticClass: "topspace"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.rvpholdreturnshipments()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search ")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-sm btn-danger leftmar ml-2",
    on: {
      "click": function($event) {
        return _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-undo"
  }), _vm._v(" Reset ")]), _vm._v(" "), _c('div', {
    staticClass: "ml-2"
  }, [_c('vue-element-loading', {
    staticStyle: {
      "background-color": "transparent"
    },
    attrs: {
      "spinner": "spinner",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)])], 1)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row mt-3 table-responsive",
    staticStyle: {
      "border": "1px solid #e0ddd9",
      "overflow-y": "auto"
    }
  }, [_c('vue-element-loading', {
    staticStyle: {
      "background-color": "transparent"
    },
    attrs: {
      "spinner": "spinner",
      "color": "#FF6700",
      "active": _vm.isLoadingtable
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingtable = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-responsive table-hover table-bordered tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', {
    staticClass: "thead-default"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tblborder"
  }, [_vm._v("Shipping ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tblborder"
  }, [_vm._v("FlyerID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tblborder"
  }, [_vm._v("ProductID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tblborder"
  }, [_vm._v("ProductDescription")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tblborder"
  }, [_vm._v("ProductImages")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tblborder"
  }, [_vm._v("SRClickedImages")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tblborder"
  }, [_vm._v("TLQCImages")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tblborder"
  }, [_vm._v("SRID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tblborder"
  }, [_vm._v("SRName")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tblborder"
  }, [_vm._v("PickupDate")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tblborder"
  }, [_vm._v("TLQCStatus")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tblborder"
  }, [_vm._v("CustomerName")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tblborder"
  }, [_vm._v("CustomerAddress")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "text-left"
  }, [_vm._l((_vm.tobereturnshipmentlist), function(shipment, sIndex) {
    return _vm._l((shipment.ProductDetails), function(product, pIndex) {
      return _c('tr', {
        key: ((shipment.ShippingID) + "-" + (product.productid))
      }, [_c('td', [_vm._v(_vm._s(shipment.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipment.Flyerbarcode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(product.productid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(product.productinfo))]), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "image-grid"
      }, _vm._l((product.productImages), function(img, i) {
        return _c('div', {
          key: i,
          staticClass: "image-item"
        }, [_c('a', {
          attrs: {
            "href": img.ImageUrl,
            "target": "_blank"
          }
        }, [_c('img', {
          attrs: {
            "src": img.ImageUrl,
            "alt": img.TextToShow
          }
        })])])
      }), 0)]), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "image-grid"
      }, _vm._l((product.srPickupImages), function(img, i) {
        return _c('div', {
          key: i,
          staticClass: "image-item"
        }, [_c('a', {
          attrs: {
            "href": img.ImageUrl,
            "target": "_blank"
          }
        }, [_c('img', {
          attrs: {
            "src": img.ImageUrl,
            "alt": img.TextToShow
          }
        })])])
      }), 0)]), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "image-grid"
      }, _vm._l((product.tlqcImages), function(img, i) {
        return _c('div', {
          key: i,
          staticClass: "image-item"
        }, [_c('a', {
          attrs: {
            "href": img.ImageUrl,
            "target": "_blank"
          }
        }, [_c('img', {
          attrs: {
            "src": img.ImageUrl,
            "alt": img.TextToShow
          }
        })])])
      }), 0)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipment.DeliveryUserId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipment.DeliveryUserName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(shipment.PickupDate)))]), _vm._v(" "), _c('td', [_vm._v("Failed")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipment.CustomerName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(shipment.CustomerAddress))])])
    })
  }), _vm._v(" "), (_vm.tobereturnshipmentlist.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "13"
    }
  }, [_vm._v("Record not found")])]) : _vm._e()], 2)])], 1), _vm._v(" "), _c('div', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading,
      "text": "Please wait"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)])], 1)])])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3961926","hasScoped":true}!./src/views/components/RVPHoldReturn/RVPHoldReturn.component.html
// module id = 1602
// module chunks = 1